<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 206 302"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M.726074 302V0H44.4009v259.963h-7.314c-1.811 0-3.3435.488-4.5973 1.464-1.2538.976-1.8808 2.23-1.8808 3.764 0 1.534.4876 2.789 1.4628 3.765 1.1145.836 2.5077 1.255 4.1794 1.255 0 1.533.4876 2.858 1.4628 3.973.9752 1.116 2.1594 1.673 3.5525 1.673 1.5325 0 2.7863-.488 3.7615-1.464.9752-1.115 1.4628-2.509 1.4628-4.182v-5.856H205.726V302H.726074Z"
      fill="currentColor"
    />
  </svg>
</template>
